<template>
  <div v-if="item.content">
    <!-- 隐藏的 audio 元素 -->
    <audio
        ref="audioElement"
        @ended="onAudioEnded"
        @error="onAudioError"
    ></audio>
    <div v-if="item.placement === 'start'&&item.status==1" class="start-action">
      <SvgIcon
          :size="20"
          color="rgb(139 139 139)"
          iconClass="action-btn"
          name="copy"
          @click.native="handleCopyMessage(item)"
      />
      <!-- 播放按钮 -->
      <img
          v-if="robot.allow_read==='1'"
          :src="isPlaying ? require('@/assets/images/chat-icon3.gif') : require('@/assets/images/chat-icon2.png')"
          alt="播放"
          class="chat-icon"
          @click="togglePlay"
      >
    </div>
  </div>
</template>

<script>
import {tts} from '@/api/chat'
import Hls from 'hls.js';

export default {
  name: 'BubbleListFooter',
  props: {
    robot: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      required: true,
    },
    client_id: {
      type: [String, Number],
      default: ''
    },
  },
  data() {
    return {
      isPlaying: false,
      hls: null,
      audioUrl: '',
      audioUrlMessageId: null, // 记录获取音频 URL 时的消息 ID
    };
  },
  mounted() {
    // 监听全局音频停止事件
    this.$root.$on('audio-stop', this.stopCurrentAudio);
  },
  beforeDestroy() {
    this.$root.$off('audio-stop', this.stopCurrentAudio);
  },
  methods: {
    // 销毁 HLS 实例
    destroyHls() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
    },

    // 切换播放/暂停
    togglePlay() {
      if (this.isPlaying) {
        this.pauseAudio();
      } else {
        // 通知其他消息停止播放
        this.$root.$emit('audio-stop', this.item.id);
        // 判断当前音频 URL 是否属于当前消息
        const isSameMessage = this.audioUrl && this.audioUrlMessageId === this.item.id;
        if (isSameMessage) {
          // 同一个消息，直接使用缓存的 URL
          this.playAudio();
        } else {
          // 不同消息或第一次播放，重新获取音频
          tts({message_id: this.item.id, client_id: this.client_id}).then((response) => {
            this.audioUrl = response.result && response.result.m3u8 ? response.result.m3u8 : null;
            this.audioUrlMessageId = this.item.id; // 记录当前消息 ID
            setTimeout(() => {
              this.playAudio();
            }, 500)
          }).catch((err) => {
            console.error('获取音频失败:', err);
            this.$message.error('获取音频失败');
          });
        }
      }
    },
    // 停止当前音频（如果是其他消息开始播放）
    stopCurrentAudio(newMessageId) {
      if (newMessageId && newMessageId !== this.item.id) {
        if (this.isPlaying) {
          this.pauseAudio();
        }
      }
    },
    // 播放音频
    playAudio() {
      const audioElement = this.$refs.audioElement;
      if (!audioElement || !this.audioUrl) return;
      this.pauseAudio();
      this.isPlaying = true;
      if (Hls.isSupported()) {
        console.debug('Hls 播放')
        // 使用 hls.js
        this.hls = new Hls({
          // // 核心：提升最小缓冲值
          // minBufferLength: 3, // 最小缓冲 2 秒（低于则暂停加载）
          // maxBufferLength: 300, // 最大缓冲 30 秒
          // maxMaxBufferLength: 60,
          // // 弱网优化
          // lowLatencyMode: false, // 关闭低延迟（优先流畅度）
        });
        this.hls.loadSource(this.audioUrl);
        this.hls.attachMedia(audioElement);
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          audioElement.play().then(() => {
            this.isPlaying = true;
          }).catch((e) => {
            console.error('播放失败:', e);
            this.isPlaying = false;
          });
        });
        this.hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS 错误:', data);
          if (data.fatal) {
            this.isPlaying = false;
            this.$message.error('音频加载失败');
          }
        });
      } else if (audioElement.canPlayType('application/vnd.apple.mpegurl')) {
        console.debug('原生播放')
        // Safari 原生支持 HLS
        audioElement.src = this.audioUrl;
        audioElement.play().then(() => {
          this.isPlaying = true;
        }).catch((e) => {
          console.error('播放失败:', e);
          this.isPlaying = false;
          this.$message.error('音频播放失败');
        });
      } else {
        this.isPlaying = false;
        this.$message.error('浏览器不支持音频播放');
      }
    },
    // 暂停音频
    pauseAudio() {
      const audioElement = this.$refs.audioElement;
      if (audioElement) {
        audioElement.pause();
        audioElement.currentTime = 0;
      }
      this.destroyHls();
      this.isPlaying = false;
    },
    // 播放结束
    onAudioEnded() {
      console.debug('播放完毕');
      this.destroyHls();
      this.isPlaying = false;
    },
    // 播放错误
    onAudioError() {
      // 只有在仍在加载或播放状态时才显示错误（避免切换时显示）
      if (this.isPlaying) {
        this.destroyHls();
        this.isPlaying = false;
        this.$message.error('音频播放错误');
      }
    },

    // 复制消息内容
    async handleCopyMessage(item) {
      if (!item.content) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(item.content);
          this.$message.success('内容已复制到剪贴板');
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = item.content;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          this.$message.success('内容已复制到剪贴板');
        }
      } catch (error) {
        console.error('复制失败:', error);
        this.$message.error('复制失败，请手动复制');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.start-action {
  display: flex;
  gap: 10px;
  align-items: center;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;

  .action-btn {
    cursor: pointer;
    border-radius: 4px;
    flex-shrink: 0;
  }
}

.chat-icon {
  width: 28px;
  height: 28px;
  cursor: pointer;
}
</style>
